document.addEventListener("DOMContentLoaded", () => {
  const productSearchInput =
    document.getElementById("product-search-input");

  const autocompleteList =
    document.getElementById("autocomplete-list");

  const resetButton =
    document.getElementById("reset-button");

  const removeFilterBtn =
    document.getElementById("remove-filter-btn");

  const filterIndicator =
    document.getElementById("filter-indicator");

  const currentFilter =
    document.getElementById("current-filter");

  const resultsSummary =
    document.getElementById("project-results-summary");

  const resultsText =
    document.getElementById("project-results-text");

  const projectsGrid =
    document.querySelector(".projects-grid");

  const menuItems =
    Array.from(document.querySelectorAll(".w-project-menu-item"));

  const projectSections =
    Array.from(document.querySelectorAll(".w-project-section"));

  if (!projectSections.length) return;

  let inputTimer;
  let updateFrame;

  /*
   * Utilities
   */

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function debounce(callback, delay = 140) {
    return (...args) => {
      window.clearTimeout(inputTimer);

      inputTimer = window.setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  function updateTotalProjectsCount(matchedCount) {
    const countElement = document.querySelector(
      ".project-total-results__count"
    );

    if (countElement) {
      countElement.textContent = matchedCount;
    }
  }

  function setActiveMenuItem(activeKey) {
    menuItems.forEach((item) => {
      item.style.fontWeight =
        item.dataset.key === activeKey ? "700" : "400";
    });
  }

  /*
   * Apply all visibility changes together.

   * This avoids delayed hide/show operations fighting with
   * one another while the user types.
   */

  function applyVisibility(matches) {
    if (updateFrame) {
      window.cancelAnimationFrame(updateFrame);
    }

    projectsGrid?.classList.add("is-filtering");

    updateFrame = window.requestAnimationFrame(() => {
      let matchedCount = 0;

      projectSections.forEach((section, index) => {
        const isVisible = Boolean(matches[index]);

        section.classList.toggle(
          "is-filtered-out",
          !isVisible
        );

        section.setAttribute(
          "aria-hidden",
          isVisible ? "false" : "true"
        );

        if (isVisible) {
          matchedCount += 1;
        }
      });

      updateTotalProjectsCount(matchedCount);

      window.requestAnimationFrame(() => {
        projectsGrid?.classList.remove("is-filtering");
      });
    });
  }

  function showAllProjects() {
    applyVisibility(
      projectSections.map(() => true)
    );
  }

  /*
   * Product line ordering
   */

  function updateProjectProductLine(
    section,
    searchTerm = ""
  ) {
    const productLine = section.querySelector(
      ".project-card__product-line"
    );

    if (!productLine) return;

    const productTitles = Array.from(
      section.querySelectorAll(".w3-product-item")
    )
      .map((item) => item.dataset.product?.trim())
      .filter(Boolean);

    if (!productTitles.length) return;

    const normalizedSearch =
      searchTerm.trim().toLowerCase();

    let orderedProducts = productTitles;

    if (normalizedSearch) {
      const matchingProducts = [];
      const remainingProducts = [];

      productTitles.forEach((title) => {
        if (
          title.toLowerCase().includes(normalizedSearch)
        ) {
          matchingProducts.push(title);
        } else {
          remainingProducts.push(title);
        }
      });

      orderedProducts = [
        ...matchingProducts,
        ...remainingProducts
      ];
    }

    const visibleProducts =
      orderedProducts.slice(0, 3);

    const remainingCount =
      orderedProducts.length - visibleProducts.length;

    let productText =
      visibleProducts.join(" • ");

    if (remainingCount > 0) {
      productText += ` • +${remainingCount} more`;
    }

    productLine.textContent = productText;
  }

  /*
   * Category filtering
   */

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", () => {
      const key = menuItem.dataset.key || "all";

      setActiveMenuItem(key);

      if (productSearchInput) {
        productSearchInput.value = "";
      }

      if (autocompleteList) {
        autocompleteList.style.display = "none";
      }

      if (resultsSummary) {
        resultsSummary.classList.add("hidden");
      }

      projectSections.forEach((section) => {
        updateProjectProductLine(section);
      });

      const matches = projectSections.map((section) => {
        return (
          key === "all" ||
          section.classList.contains(
            `w-project-section-${key}`
          )
        );
      });

      applyVisibility(matches);
    });
  });

  /*
   * Build product search index
   */

  /*
 * Build search index:
 * project names + product names
 */

const searchMap = new Map();

projectSections.forEach((section) => {
  const projectTitle =
    section
      .querySelector(".project-card__title")
      ?.textContent.trim();
  
 const projectType =
  section
    .querySelector(".project-card__type")
    ?.textContent.trim().toLowerCase() || "";

  const projectImage =
    section.querySelector(".project-card__image")?.src || "";

  if (projectTitle) {
    const key = `project:${projectTitle.toLowerCase()}`;

    searchMap.set(key, {
      name: projectTitle,
      image: projectImage,
      type: "project"
    });
  }

  section
    .querySelectorAll(".w3-product-item")
    .forEach((item) => {
      const productName =
        item.dataset.product?.trim();

      const productImage =
        item.dataset.image || "";

      if (!productName) return;

      const key = `product:${productName.toLowerCase()}`;

      if (!searchMap.has(key)) {
        searchMap.set(key, {
          name: productName,
          image: productImage,
          type: "product"
        });
      }
    });
});

const searchItems = Array.from(searchMap.values());

function showSuggestions(value) {
  if (!autocompleteList) return;

  const normalizedValue =
    value.trim().toLowerCase();

  const matches = searchItems
    .filter((item) =>
      item.name.toLowerCase().includes(normalizedValue)
    )
    .sort((a, b) => {
      const aStarts =
        a.name.toLowerCase().startsWith(normalizedValue);

      const bStarts =
        b.name.toLowerCase().startsWith(normalizedValue);

      if (aStarts !== bStarts) {
        return aStarts ? -1 : 1;
      }

      if (a.type !== b.type) {
        return a.type === "project" ? -1 : 1;
      }

      return a.name.localeCompare(b.name);
    })
    .slice(0, 10);

  if (!matches.length) {
    autocompleteList.innerHTML = `
      <div class="autocomplete-suggestion">
        There are no matches
      </div>
    `;

    autocompleteList.style.display = "block";
    return;
  }

  autocompleteList.innerHTML = matches
    .map((item) => {
      const safeName = escapeHtml(item.name);

      const imageMarkup = item.image
        ? `
          <img
            src="${escapeHtml(item.image)}"
            alt=""
            loading="lazy"
          >
        `
        : "";

      const label =
        item.type === "project"
          ? "Project"
          : "Product";

      return `
        <div
          class="autocomplete-suggestion"
          data-value="${safeName}"
        >
          ${imageMarkup}

          <span>
            <span class="autocomplete-suggestion__content">
              <span class="autocomplete-suggestion__name">
                ${safeName}
              </span>

              <small class="autocomplete-suggestion__type">
                ${label}
              </small>
            </span>
          </span>
        </div>
      `;
    })
    .join("");

  autocompleteList.style.display = "block";
}

  /*
   * Product filtering
   */

  function filterProjects(searchTerm) {
  const normalizedSearch =
    searchTerm.trim().toLowerCase();

  if (!normalizedSearch) {
    clearFilter();
    return;
  }

  setActiveMenuItem("");

  const matches = projectSections.map((section) => {
    const projectTitle =
      section
        .querySelector(".project-card__title")
        ?.textContent.trim().toLowerCase() || "";

        const projectType =
  section
    .querySelector(".project-card__type")
    ?.textContent.trim().toLowerCase() || "";

    const projectMatches =
  projectTitle.includes(normalizedSearch) ||
  projectType.includes(normalizedSearch);

    const sectionProducts = Array.from(
      section.querySelectorAll(".w3-product-item")
    );

    const productMatches = sectionProducts.some((product) => {
      const productName =
        product.dataset.product?.toLowerCase() || "";

      const productTags =
        product.dataset.tags?.toLowerCase() || "";

      const nativeProductType =
        product.dataset.nativeProductType?.toLowerCase() || "";

      const productTypes =
        product.dataset.productTypes?.toLowerCase() || "";

      return (
        productName.includes(normalizedSearch) ||
        productTags.includes(normalizedSearch) ||
        nativeProductType.includes(normalizedSearch) ||
        productTypes.includes(normalizedSearch)
      );
    });

    const isMatch =
  projectMatches || productMatches;

    if (isMatch) {
      updateProjectProductLine(
        section,
        searchTerm
      );
    }

    return isMatch;
  });

  const matchedCount =
    matches.filter(Boolean).length;

  applyVisibility(matches);

  if (filterIndicator) {
    filterIndicator.classList.remove("hidden");
  }

  if (currentFilter) {
    currentFilter.textContent = searchTerm;
  }

  if (resultsSummary && resultsText) {
    resultsSummary.classList.remove("hidden");

    resultsText.innerHTML = `
      <strong>${matchedCount}</strong>
      ${matchedCount === 1 ? "project" : "projects"}
      matching "<strong>${escapeHtml(searchTerm)}</strong>"
    `;
  }
}

  function clearFilter() {
    window.clearTimeout(inputTimer);

    if (productSearchInput) {
      productSearchInput.value = "";
    }

    if (autocompleteList) {
      autocompleteList.style.display = "none";
      autocompleteList.innerHTML = "";
    }

    if (filterIndicator) {
      filterIndicator.classList.add("hidden");
    }

    if (currentFilter) {
      currentFilter.textContent = "";
    }

    if (resultsSummary) {
      resultsSummary.classList.add("hidden");
    }

    if (resultsText) {
      resultsText.textContent = "";
    }

    setActiveMenuItem("all");

    projectSections.forEach((section) => {
      updateProjectProductLine(section);
    });

    showAllProjects();
  }

  /*
   * Search events
   */

  const handleSearchInput = debounce(() => {
    if (!productSearchInput) return;

    const value =
      productSearchInput.value.trim();

    if (value.length >= 2) {
     // showSuggestions(value);
      filterProjects(value);
    } else {
      if (autocompleteList) {
        autocompleteList.style.display = "none";
      }

      if (resultsSummary) {
        resultsSummary.classList.add("hidden");
      }

      projectSections.forEach((section) => {
        updateProjectProductLine(section);
      });

      setActiveMenuItem("all");
      showAllProjects();
    }
  });

  productSearchInput?.addEventListener(
    "input",
    handleSearchInput
  );

  productSearchInput?.addEventListener(
    "keydown",
    (event) => {
      if (event.key !== "Enter") return;

      event.preventDefault();
      window.clearTimeout(inputTimer);

      const value =
        productSearchInput.value.trim();

      if (!value) return;

      if (autocompleteList) {
        autocompleteList.style.display = "none";
      }

      filterProjects(value);
    }
  );

 // autocompleteList?.addEventListener(
 //   "click",
 //   (event) => {
 //     const suggestion = event.target.closest(
 //       ".autocomplete-suggestion[data-value]"
  //    );
//
//      if (!suggestion) return;
//
//      const productName =
//        suggestion.dataset.value;
//
//      autocompleteList.style.display = "none";
//      filterProjects(productName);
//    }
//  );

  resetButton?.addEventListener(
    "click",
    clearFilter
  );

  removeFilterBtn?.addEventListener(
    "click",
    clearFilter
  );

  /*
   * Initial state
   */

  setActiveMenuItem("all");
  showAllProjects();
});
